import { Fieldset, Radio, Textfield, ValidationMessage } from '@digdir/designsystemet-react';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { parseNorwegianFormattedNumber } from '../../../../../../utils/utils';
import { useSolcelleFormContext } from '../utils';
import { useSolcellerValidation } from '../useSolcellerValidation';

export const SolarSharing = () => {
  const { t } = useTranslation();
  const { register, watch, formState } = useSolcelleFormContext();
  const { integerPattern, validateDistributionPercent, validateTotalSharedBoenheter } =
    useSolcellerValidation();

  const sharedSolarInstallation = watch('sharedSolarInstallation');
  const sharedSolarDistribution = watch('sharedSolarDistribution');

  return (
    <Fragment>
      <Fieldset>
        <Fieldset.Legend>{t('register.solar.form.sharing.label')}</Fieldset.Legend>
        <Radio
          {...register('sharedSolarInstallation', { required: t('register.solar.form.sharing.error') })}
          label={t('register.solar.form.sharing.option.onlyThis')}
          value="no"
        />
        <Radio
          {...register('sharedSolarInstallation', { required: t('register.solar.form.sharing.error') })}
          label={t('register.solar.form.sharing.option.shared')}
          value="yes"
        />
        {formState.errors.sharedSolarInstallation && (
          <ValidationMessage data-color="danger">
            {formState.errors.sharedSolarInstallation.message}
          </ValidationMessage>
        )}
      </Fieldset>

      {sharedSolarInstallation === 'yes' && (
        <Fieldset>
          <Fieldset.Legend>{t('register.solar.form.sharing.distribution.label')}</Fieldset.Legend>
          <Radio
            {...register('sharedSolarDistribution', {
              required: t('register.solar.form.sharing.distribution.error')
            })}
            label={t('register.solar.form.sharing.distribution.option.equal')}
            value="equal"
          />
          <Radio
            {...register('sharedSolarDistribution', {
              required: t('register.solar.form.sharing.distribution.error')
            })}
            label={t('register.solar.form.sharing.distribution.option.percentage')}
            value="percentage"
          />
          {formState.errors.sharedSolarDistribution && (
            <ValidationMessage data-color="danger">
              {formState.errors.sharedSolarDistribution.message}
            </ValidationMessage>
          )}
        </Fieldset>
      )}

      {sharedSolarInstallation === 'yes' && sharedSolarDistribution === 'equal' && (
        <Textfield
          type="text"
          inputMode="numeric"
          {...register('totalSharedBoenheter', {
            setValueAs: (value: unknown) => {
              if (value === '' || value === undefined || value === null) {
                return undefined;
              }
              const n = Number(value);
              return Number.isNaN(n) ? undefined : n;
            },
            pattern: integerPattern,
            validate: validateTotalSharedBoenheter
          })}
          error={formState.errors.totalSharedBoenheter?.message}
          label={t('register.solar.form.sharing.totalUnits.label')}
        />
      )}

      {sharedSolarInstallation === 'yes' && sharedSolarDistribution === 'percentage' && (
        <Textfield
          type="text"
          inputMode="numeric"
          {...register('fordelingsnokkelPercent', {
            setValueAs: (value) => parseNorwegianFormattedNumber(value),
            validate: validateDistributionPercent
          })}
          error={formState.errors.fordelingsnokkelPercent?.message}
          label={t('register.solar.form.sharing.percentage.label')}
          suffix="%"
        />
      )}
    </Fragment>
  );
};
